<template>
    <ValidationProvider :rules="validationRules" :name="name || label" :vid="validationId" v-slot="{ errors }"
        slim>

		<OaoDateInput
			:value="value"
			:label="label"
			:placeholder="placeholder"
			:disabled="disabled"
			:error="errors[0]"
            :isSmall="isSmall"
			:hideLabel="hideLabel"
            :sublabel="sublabel"
            :sublabelWarning="sublabelWarning"
			:tooltip="tooltip"
			:tooltipTypeId="tooltipTypeId"
			:minDate="minDate"
			:maxDate="maxDate"
			:isOptional="isOptional"
			:disableAutocomplete="disableAutocomplete"
			:gliaMask="gliaMask"
			:gliaDisable="gliaDisable"
			@input="$emit('input', $event)"
			@blur="$emit('blur', $event)"
			@change="$emit('change', $event)"
		/>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import OaoDateInput from '@/components/form/OaoDateInput';

export default {
	name: 'OaoFormDateInput',
	components: {
		ValidationProvider,
		OaoDateInput
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			required: true
		},
		placeholder: {
			type: String,
			default: 'MM/DD/YYYY'
		},
		disabled: {
			type: Boolean,
			default: false
		},
		validationRules: {
			type: [Object, String],
			default: ''
		},
        isSmall: {
            type: Boolean,
            required: false,
            default: false,
        },
		tooltip: {
			type: Boolean,
			default: false
		},
		tooltipTypeId: {
			type: Number,
			default: null
		},
        hideLabel: {
            type: Boolean,
            required: false,
        },
        sublabel: {
            type: String,
            required: false
        },
        sublabelWarning: {
            type: Boolean,
            required: false
        },
		minDate: {
			type: String,
			default: ''
		},
		maxDate: {
			type: String,
			default: ''
		},
		isOptional: {
			type: Boolean,
			default: false
		},
		disableAutocomplete: {
			type: Boolean,
			default: false
		},
		gliaMask: {
			type: Boolean,
			default: false
		},
		gliaDisable: {
			type: Boolean,
			default: false
		},
		name: {
			type: String,
			default: ''
		},
		validationId: {
            type: String,
            required: false
        }
	}
};
</script>
